require('initializers/gettext').default(__TRANSLATIONS__.gettext.lt); // eslint-disable-line no-undef
require('initializers/i18n').default('lt', __TRANSLATIONS__.i18n.lt); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/lt');
require('jquery-ui/ui/i18n/datepicker-lt');
require('dayjs/locale/lt');
